<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" @getOtherFormVal="getOtherFormVal" />
      <DetailForm ref="detailForm" @getOtherFormVal="getOtherFormVal" />
      <Receipt ref="receipt" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import DetailForm from './detail/detail';
import Receipt from './receipt';
import SubBtnBox from 'components/subBtnBox';
import {
  maintenanceCostEdit,
  maintenanceDetail,
} from 'api/cost';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    DetailForm,
    Receipt,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/cost/car/apply/costApply',
      formComponents: ['baseForm', 'detailForm', 'receipt'],
      editParams: {
        isPreApply: 1,
      },
    };
  },
  computed: {
    detailParams () {
      return {
        applyId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: maintenanceDetail,
    editApi: maintenanceCostEdit,
    async getOtherFormVal ({ from, tar }) {
      const tarFormData = await this.$refs[tar].cacheData();
      this.$refs[from].receiveData(tar, tarFormData);
    },
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
